module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat6-748ceec83561b248fba989698bd49aba.svg";